import ReactDOMServer from 'react-dom/server';
import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';

// components

// leaflet
import L from 'leaflet';
import {
  Marker, Popup, Tooltip,
} from 'react-leaflet';
import StyledMarker from '../../../components/marker/Marker';
import 'leaflet/dist/leaflet.css';

import '../../../components/map/Style.css';

import { styles } from '../style';

const useStyles = makeStyles(styles);
const styleMarker = {
  type: 'wave',
  level3: {
    icon: 'WaveIcon',
    label: 'shapeCircle',
    color: '#ff0000',
  },
};

export default function WaveMap(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { datas } = props;

  const eachData = (data, i) => {
    if (data.tele_station_lat && data.tele_station_long) {
      // marker position
      const position = [parseFloat(data.tele_station_lat),
        parseFloat(data.tele_station_long)];

      // marker icons
      const styleClass = styleMarker.level3;
      const icon = L.divIcon({
        className: 'styleClass',
        html: ReactDOMServer.renderToString(<StyledMarker
          category={styleMarker.type}
          type={styleClass}
        />),
      });

      return (
        <Marker
          id={data.id}
          key={i}
          position={position}
          icon={icon}
        >
          <Popup autoPan={false}>
            <TableContainer>
              <Table size="small">
                <TableHead />
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.hiddenLine} padding="none" align="center" colSpan={3}>
                      <Box fontWeight="500" fontFamily="Kanit" fontSize="14px">
                        {data.name}
                      </Box>
                      <Box fontFamily="Kanit" fontSize="12px">
                        {`จ. ${data.province_name}`}
                      </Box>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.hiddenLine}>
                      <Box fontWeight={600} fontSize={12}>
                        {t('ความสูงคลื่น')}
                      </Box>
                    </TableCell>
                    <TableCell className={classes.hiddenLine} align="center">
                      {data.wave_height}
                    </TableCell>
                    <TableCell className={classes.hiddenLine} align="left">
                      (
                      {t('เมตร')}
                      )
                    </TableCell>
                  </TableRow>
                  {/* <TableRow>
                    <TableCell
                      className={classes.hiddenLine}
                      style={{ paddingTop: 10 }}
                      colSpan={2}
                    >
                      <Box color="text.disabled" fontSize="8px">
                        {`ข้อมูล: ${data.agency_name}`}
                      </Box>
                      <Box color="text.disabled" fontSize="8px">
                        {'ล่าสุด : '}
                        {data.datetime}
                        {' '}
                        {'น.'}
                      </Box>
                    </TableCell>
                  </TableRow> */}
                </TableBody>
              </Table>
            </TableContainer>
          </Popup>
          <Hidden smDown>
            <Tooltip>
              <span>
                <strong>
                  {data.name}
                </strong>
                <br />
                {`จ. ${data.province_name}`}
              </span>
            </Tooltip>
          </Hidden>
        </Marker>
      );
    }
    return false;
  };

  return (
    <>
      {datas.map(eachData)}
    </>
  );
}

WaveMap.propTypes = {
  datas: PropTypes.instanceOf(Array).isRequired,
};
